module.exports = __webpack_public_path__ + "static/media/bg_page89.6139779b.png";